module.exports = __webpack_public_path__ + "img/bsg-pro-sofas2024.942cc205.png";